import React, { useState, useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";
import AdminReportDataService from "../../../services/admin-report.service";

import { useSelector } from "react-redux";
import { Button, Modal, Spin, Table, Tooltip } from "antd";

/*Initial State for Binding Starts*/
const initialClientsReportState = {
  clientsReportRadio: "jewelryVendor",
};
/*Initial State for Binding Ends*/

const ClientsReports = () => {
  const { t } = useTranslation();
  const [visible, setOpen] = useState(false);
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [globalEvents, setGlobalEvents] = useState(initialClientsReportState);
  const [downloadDataloading, setDownloadDataloading] = useState(false);
  const [clientReportsGridDataList, setClientReportsGridDataList] = useState(
    []
  );
  const [clientDetailsList, setClientDetailsList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortColumnName, setSortColumnName] = useState("DealerId");
  const [sortType, setSortType] = useState("asc");
  const [EventsCount, setEventsCount] = useState(0);
  const [TotalEventsCount, setTotalEventsCount] = useState(0);
  const [key, setKey] = useState(true);
  const clientsReportRadioRef = useRef(null);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
        }
        handleGetClientVendorRetailerReportsData(
          pageNo,
          pageSize,
          sortColumnName,
          sortType
        );
      }
    }
  }, []);

  const handleOnChangeRadio = (event) => {
    setGlobalEvents({
      ...globalEvents,
      clientsReportRadio: event.target.name,
    });
  };

  const OnDetailsClick = (item) => {
    setOpen(true);
    handleLoadDataByClientID(dealerId, item.dealerID);
  };

  /*API Binding Starts*/
  const handleGetClientVendorRetailerReportsData = (
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder
  ) => {

    let clientTypeKey = globalEvents.clientsReportRadio;
    if (globalEvents.clientsReportRadio === "jewelryVendor") {
      clientTypeKey = "vendor";
    } else if (globalEvents.clientsReportRadio === "diamondVendor") {
      clientTypeKey = "vendordiamond";
    } else if (globalEvents.clientsReportRadio === "retailer") {
      clientTypeKey = "retailer";
    }
    
    clientsReportRadioRef.current = clientTypeKey;
    let inputData = {
      pageIndex: pageNo,
      pageSize: pageSize,
      sortColumnName: sortColumnName || "DealerId",
      sortOrder: sortOrder || "ASC",
      clientType: clientTypeKey,
    };

    setTableLoading(true);
    AdminReportDataService.GetClientVendorRetailerReportsData(inputData)
      .then((response) => {  
        var message = response.data.message;
        var responseData = response.data.responseData;
        var clientReportsGridDataList =
          response.data.responseData.clientVendorRetailerReportsresplistData;
        var TotalEventsCount =
          response.data.responseData.clientVendorRetailerReportsresplistData[0]
            .totalcount;
        if (message === "Success") {
          if (responseData) {
            var temptotalRecords = clientReportsGridDataList[0].totalcount;
            setTotalCount(temptotalRecords);
            setEventsCount(pageSize);
            setTotalEventsCount(TotalEventsCount);
            setClientReportsGridDataList(clientReportsGridDataList);
          }
        } else {
          setClientReportsGridDataList([]);
          setTotalCount(0);
          setEventsCount(pageSize);
          setTotalEventsCount(0);
        }
      })
      .catch((error) => {
        setTableLoading(false);
        setClientReportsGridDataList([]);
        setEventsCount(0);
        setTotalEventsCount(0);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const handleLoadDataByClientID = (dealerId, clientID) => {
    let clientTypeKey = globalEvents.clientsReportRadio;
    if (globalEvents.clientsReportRadio === "jewelryVendor") {
      clientTypeKey = "vendor";
    } else if (globalEvents.clientsReportRadio === "diamondVendor") {
      clientTypeKey = "vendordiamond";
    } else if (globalEvents.clientsReportRadio === "retailer") {
      clientTypeKey = "retailer";
    }
    let inputData = {
      dealerID: dealerId.toString(),
      clientID: clientID.toString(),
      clientType: clientTypeKey,
    };
    setDetailsLoading(true);
    AdminReportDataService.LoadDataByClientID(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var clientDetailsList = response.data.responseData;
        if (message === "Success") {
          if (responseData) {
            setClientDetailsList(clientDetailsList);
          }
        } else {
          setClientDetailsList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setDetailsLoading(false);
        setClientDetailsList([]);
      })
      .finally(() => {
        setDetailsLoading(false);
      });
  };
  const handleDownloadClientreportCSV_ServerClick = () => {
    let inputData = {
      orderBy: "",
      clientType: clientsReportRadioRef?.current ?? "",
    };
    setDownloadDataloading(true);
    AdminReportDataService.downloadClientreportCSV_ServerClick(inputData)
      .then((response) => {
        openInNewTab(response.data.responseData);
      })
      .catch((error) => {
        setDownloadDataloading(false);
        console.log(error);
      })
      .finally(() => setDownloadDataloading(false));
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const handleApplyFilter = () => {
       setPageNo(1);
    setPageSize(15);
    setKey(!key);
    
    let clientTypeKey = globalEvents.clientsReportRadio;
    if (globalEvents.clientsReportRadio === "jewelryVendor") {
      clientTypeKey = "vendor";
    } else if (globalEvents.clientsReportRadio === "diamondVendor") {
      clientTypeKey = "vendordiamond";
    } else if (globalEvents.clientsReportRadio === "retailer") {
      clientTypeKey = "retailer";
    }
      
    handleGetClientVendorRetailerReportsData(1, 15, sortColumnName, sortType);
  };

  /*Sorting API Starts*/
  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "DealerId";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetClientVendorRetailerReportsData(
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*Sorting API Ends*/

  /*API Binding Ends*/
  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields magento__mapping">
        <div className="row">
          <div className="col-md-12">
            <div className="heading__block mobile-m-0">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Clients Reports")}
              </h4>
              
            </div>
          </div>
          <div className="col-md-12">
            <div className="row justify-baseline">
              <div className="col-md-2">
                <div className="uplaod__file">
                  <div className="radio__block col">
                    <div className="radio__btn">
                      <input
                        type="radio"
                        id="jewelryVendor"
                        name="jewelryVendor"
                        value={globalEvents.clientsReportRadio}
                        checked={
                          globalEvents.clientsReportRadio === "jewelryVendor"
                            ? true
                            : false
                        }
                        onChange={handleOnChangeRadio}
                      />
                      <label htmlFor="jewelryVendor"> {t("Jewelry Vendor")}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 ">
                <div className="uplaod__file">
                  <div className="radio__block col">
                    <div className="radio__btn">
                      <input
                        type="radio"
                        id="diamondVendor"
                        name="diamondVendor"
                        value={globalEvents.clientsReportRadio}
                        checked={
                          globalEvents.clientsReportRadio === "diamondVendor"
                            ? true
                            : false
                        }
                        onChange={handleOnChangeRadio}
                      />
                      <label htmlFor="diamondVendor"> {t("Diamond Vendor")}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-1">
                <div className="uplaod__file">
                  <div className="radio__block col">
                    <div className="radio__btn">
                      <input
                        type="radio"
                        id="Retailer"
                        name="retailer"
                        value={globalEvents.clientsReportRadio}
                        checked={
                          globalEvents.clientsReportRadio === "retailer"
                            ? true
                            : false
                        }
                        onChange={handleOnChangeRadio}
                      />
                      <label htmlFor="Retailer"> {t("Retailer")}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <div className="button__block mobile-m-0">
                  <button
                    className="primary-btn mr-2"
                    onClick={handleApplyFilter}
                  >
                    {" "}
                    {t("Apply Filter")}{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="limit_section">
            <div className="col-lg-12 mt-3">
              <div className="options__div">
                <div className="row">
                  <div className="col-lg-4 rules__div">
                    <span className="rules__txt">
                      {" "}
                      <span className="rules__txtno">
                        {EventsCount > TotalEventsCount ? (
                          <span className="rules__txtno">
                            {TotalEventsCount} / {TotalEventsCount}
                          </span>
                        ) : (
                          <span className="rules__txtno">
                            {EventsCount} / {TotalEventsCount}
                          </span>
                        )}
                      </span>{" "}
                      {t("Events")}
                    </span>
                  </div>

                  <div  className="col-lg-8 crud__div">
                    <Button
                      className="primary-btn"
                      onClick={() => handleDownloadClientreportCSV_ServerClick()}
                      loading={downloadDataloading}
                      >
                      {" "}
                      <i className="fa fa-download"></i> {t("Download")}
                    </Button>
                  </div>
                  
                </div>
              </div>
            </div>

          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              key={key}
              className="pendjewelreq__tbl"
              loading={tableLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("Dealer ID")}>{t("Dealer ID")}</Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "dealerID",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Dealer Company")}>
                      {t("Dealer Company")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "dealerCompany",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: <Tooltip title={t("Jewelry")}>{t("Jewelry")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "totalJewelry",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Diamonds")}>{t("Diamonds")}</Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "totalDiamonds",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Connections")}>
                      {t("Connections")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "totalConnected",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Pending Requests")}>
                      {t("Pending Requests")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "totalPendingReq",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: <Tooltip title={t("Status")}>{t("Status")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "accountStatus",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Last Updated")}>
                      {t("Last Updated")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "modifiedDate",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: (
                    <Tooltip title={t("Days Old")}>{t("Days Old")}</Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "daysOld",
                  sorter: (a, b) => {},
                  showSorterTooltip: false,
                },
                {
                  title: <Tooltip title={t("Details")}>{t("Details")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "details",
                  showSorterTooltip: false,
                  render: (item, row) => {
                    return (
                      <React.Fragment>
                        <span
                          className="linkText"
                          onClick={() => OnDetailsClick(row)}
                        >
                          {t(row.details)}
                        </span>
                      </React.Fragment>
                    );
                  },
                },
              ]}
              dataSource={clientReportsGridDataList}
              scroll={{ y: "calc(100vh - 340px)" }}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>

          <Modal
            title={t("Connected and Pending Request Details")}
            centered
            visible={visible}
            okText={t("OK")}
            cancelText={t("Cancel")}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            width={800}
          >
            <div className="request__modal">
              <Spin spinning={detailsLoading}>
                <div className="row">
                  {clientDetailsList.length !== 0 &&
                    clientDetailsList.map((item) => {
                      return (
                        <React.Fragment>
                          <div className="col-md-4 p-0">
                            <div className="request__block">
                              <div className="top__name">
                                <p>
                                  {item.dealerCompany} ({item.dealerID})
                                </p>
                                {item.dealerStatus == "C" && (
                                  <span className="status">
                                    {item.dealerStatus}
                                  </span>
                                )}
                                {item.dealerStatus == "P" && (
                                  <span className="status pending">
                                    {item.dealerStatus}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  {clientDetailsList.length == 0 && (
                    <h4 className="text-center">{t("No Data Available.")}</h4>
                  )}
                </div>
              </Spin>
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ClientsReports;
